.kh{font-family:inherit;}